export const BRIEF_SECTION_CLASS_NAME = 'brief-section';
